import React, { useCallback, useState } from 'react';
import ReactQuill from 'react-quill';

import { texts } from 'utils/languages/fr';

import { ExpandableList } from 'components';
import { Box, Typography } from '@mui/material';
import 'react-quill/dist/quill.bubble.css';

const Message = ({ id, title, content }) => (
    <ExpandableList title={title}>
        <ReactQuill value={content} readOnly theme="bubble" />
    </ExpandableList>
);

const MessageGroup = ({ messages }) => {
    const [expandedMessageId, setExpandedMessageId] = useState(null);
    const handleToggleExpand = useCallback(
        id => e => {
            setExpandedMessageId(prevState => (prevState === id ? null : id));
        },
        []
    );

    const hasMessages = Array.isArray(messages) && messages.length > 0;

    if (!hasMessages) {
        return (
            <Box textAlign="center">
                <Typography>{texts.NO_MESSAGE}</Typography>
            </Box>
        );
    }

    return (
        <Box display="flex" flexDirection="column">
            {messages.map(message => (
                <Message
                    key={message.id}
                    id={message.id}
                    expanded={expandedMessageId === message.id}
                    onToggleExpand={handleToggleExpand(message.id)}
                    title={message.title}
                    content={message.content}
                />
            ))}
        </Box>
    );
};

export default MessageGroup;
